import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Notification {
  id: number;
  title: string;
  template_key: string;
  is_read: boolean;
  created_at: string;
  page_data?: {
    name: string;
    data?: {
      chat_room_key?: string;
      chat_room_type?: string;
      [key: string]: unknown;
    };
  };
  groupedMessagesArray?: Notification[];
}

export interface NotificationsResponse {
  body: Notification[];
  totalRecords: string | null;
}

export interface NotificationSetting {
  notification_type_id: number;
  settings?: {
    channels?: string[];
    allowed_time_ranges?: unknown[];
    rate_limit?: number;
    snooze_until?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api_url;

  getNotifications(page = 1, perPage = 11): Observable<NotificationsResponse> {
    const url = `${this.baseUrl}api/v1/customer/notifications?page=${page}&per_page=${perPage}`;
    return this.http.get<Notification[]>(url, { observe: 'response' }).pipe(
      map((response: HttpResponse<Notification[]>) => ({
        body: response.body || [],
        totalRecords: response.headers.get('X-Total-Records')
      }))
    );
  }

  getNotificationSettings(): Observable<NotificationSetting[]> {
    const url = `${this.baseUrl}api/v1/customer/notification-settings`;
    return this.http.get<NotificationSetting[]>(url);
  }

  updateNotificationSetting(data: NotificationSetting): Observable<unknown> {
    const url = `${this.baseUrl}api/v1/customer/notification-settings`;
    return this.http.put(url, data);
  }

  markAsRead(notificationId: number): Observable<unknown> {
    const url = `${this.baseUrl}api/v1/customer/notifications/${notificationId}/mark-as-read`;
    return this.http.post(url, {});
  }

  markAllAsRead(): Observable<unknown> {
    const url = `${this.baseUrl}api/v1/customer/notifications/mark-all-as-read`;
    return this.http.post(url, {});
  }
}
